import { addMonths, isPast, startOfMonth, subDays } from 'date-fns';

import {
    AgencyCapacityReminder,
    AgencyCapacityReminderConfigurator,
    AgencyCapacityReminderType,
    CollectCapacityReminderContext,
} from '../CollectCapacityReminderConfigurator';
import { getSnoozedUntil } from '../CollectCapacityReminderSnoozeHandler';

export class AgencyCapacityNeedToBeFilledConfigurator implements AgencyCapacityReminderConfigurator {
    currentDate: Date;

    constructor() {
        this.currentDate = new Date();
    }

    support(context: CollectCapacityReminderContext): boolean {
        return (
            !context.agencyCapacityFillingStatus.nextMonthIsFilled ||
            !context.agencyCapacityFillingStatus.secondNextMonthIsFilled
        );
    }

    get(context: CollectCapacityReminderContext): AgencyCapacityReminder | null {
        const snoozedUntil: Date | null = getSnoozedUntil(
            AgencyCapacityReminderType.CapacityNeedToBeFilled,
        );

        const initialReminderDateForSecondNextMonth = this.calculateInitialReminderDate(2);
        const isSecondNextMonthReminderEligible =
            isPast(initialReminderDateForSecondNextMonth) &&
            !context.agencyCapacityFillingStatus.secondNextMonthIsFilled;

        if (isSecondNextMonthReminderEligible) {
            return {
                type: AgencyCapacityReminderType.CapacityNeedToBeFilled,
                remindAt: snoozedUntil ? snoozedUntil : initialReminderDateForSecondNextMonth,
                relatedMonth: addMonths(this.currentDate, 2).getMonth(),
            };
        }

        const initialReminderDateForNextMonth = this.calculateInitialReminderDate(1);
        const isNextMonthReminderEligible =
            isPast(initialReminderDateForNextMonth) &&
            !context.agencyCapacityFillingStatus.nextMonthIsFilled;

        if (isNextMonthReminderEligible) {
            return {
                type: AgencyCapacityReminderType.CapacityNeedToBeFilled,
                remindAt: snoozedUntil ? snoozedUntil : initialReminderDateForNextMonth,
                relatedMonth: addMonths(this.currentDate, 1).getMonth(),
            };
        }

        return null;
    }

    private calculateInitialReminderDate(monthOffset: number): Date {
        return subDays(startOfMonth(addMonths(this.currentDate, monthOffset)), 45);
    }
}
